export default __webpack_public_path__ + "static/media/sqldb.9d30f76d.webp";